export default [
    {
        path: '/babyIndex', // 婴儿儿童票首页
        component: resolve => require(['@/pages/babytk/babyIndex'], resolve),
        name: '婴儿/儿童订票'
    },
    {
        path: '/babyFlight', // 婴儿儿童票航班列表
        component: resolve => require(['@/pages/babytk/babyFlight'], resolve),
        name: '婴儿/儿童订票'
    },
    {
        path: '/babyTKKnow', // 婴儿儿童票预订须知
        component: resolve => require(['@/pages/babytk/babyTKKnow'], resolve),
        name: '婴儿/儿童订票'
    },
    {
        path: '/babyCabin', // 婴儿儿童票舱位信息
        component: resolve => require(['@/pages/babytk/babyCabin'], resolve),
        name: '婴儿/儿童订票'
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/babytk.js